import { createClient as createSupabaseClient, SupabaseClient } from '@supabase/supabase-js';

let supabaseInstance: SupabaseClient | null = null;

function clearAllAuthData() {
  console.log('[Supabase] Clearing all auth data...');

  const keysToRemove = [];
  for (let i = 0; i < localStorage.length; i++) {
    const key = localStorage.key(i);
    if (key && key.includes('supabase')) {
      keysToRemove.push(key);
    }
  }
  keysToRemove.forEach(key => localStorage.removeItem(key));

  sessionStorage.clear();

  document.cookie.split(";").forEach((c) => {
    document.cookie = c.replace(/^ +/, "").replace(/=.*/, "=;expires=" + new Date().toUTCString() + ";path=/");
  });
}

if (typeof window !== 'undefined') {
  try {
    const authKeys = Object.keys(localStorage).filter(key => key.includes('supabase.auth'));

    authKeys.forEach(key => {
      try {
        const data = localStorage.getItem(key);
        if (data) {
          const parsed = JSON.parse(data);

          if (parsed.access_token && parsed.expires_at) {
            const expiresAt = parsed.expires_at * 1000;
            const now = Date.now();

            if (now > expiresAt && !parsed.refresh_token) {
              console.warn('[Supabase] Found expired session with no refresh token, clearing');
              clearAllAuthData();
            }
          }
        }
      } catch (e) {
        console.warn('[Supabase] Invalid auth data found, clearing');
        clearAllAuthData();
      }
    });
  } catch (e) {
    console.error('[Supabase] Error checking auth state:', e);
  }
}

export function createClient() {
  if (supabaseInstance) {
    return supabaseInstance;
  }

  const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
  const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

  if (!supabaseUrl || !supabaseAnonKey) {
    console.error('[Supabase Client] Environment check failed:', {
      hasUrl: !!supabaseUrl,
      hasKey: !!supabaseAnonKey,
      mode: import.meta.env.MODE,
      allEnvVars: Object.keys(import.meta.env)
    });
    throw new Error(
      `Missing Supabase environment variables. ` +
      `URL: ${supabaseUrl ? 'Set' : 'Missing'}, ` +
      `Key: ${supabaseAnonKey ? 'Set' : 'Missing'}. ` +
      `Make sure VITE_SUPABASE_URL and VITE_SUPABASE_ANON_KEY are configured in your deployment platform.`
    );
  }

  supabaseInstance = createSupabaseClient(supabaseUrl, supabaseAnonKey, {
    auth: {
      persistSession: true,
      autoRefreshToken: true,
      detectSessionInUrl: true,
      flowType: 'pkce',
      storage: {
        getItem: (key: string) => {
          const item = localStorage.getItem(key);
          return item;
        },
        setItem: (key: string, value: string) => {
          try {
            localStorage.setItem(key, value);
          } catch (e) {
            console.error('[Supabase] Error storing auth data:', e);
          }
        },
        removeItem: (key: string) => {
          localStorage.removeItem(key);
        }
      }
    }
  });

  console.log('[Supabase] Created singleton client instance');
  return supabaseInstance;
}

export const supabase = createClient();
